export type QualityLevel = 'low' | 'medium' | 'high';

export interface QualityProfile {
  /** Paint render-target resolution for the main ground surface. */
  paintTextureSize: number;
  /** Paint render-target resolution for small prop surfaces (car roofs, glass). */
  paintTextureSizeSmall: number;
  maxSnowParticles: number;
  shadowMapSize: number;
  shadowsEnabled: boolean;
  maxPixelRatio: number;
}

export const QUALITY_PROFILES: Record<QualityLevel, QualityProfile> = {
  low: {
    paintTextureSize: 1024,
    paintTextureSizeSmall: 256,
    maxSnowParticles: 6000,
    shadowMapSize: 512,
    shadowsEnabled: false,
    maxPixelRatio: 1,
  },
  medium: {
    paintTextureSize: 2048,
    paintTextureSizeSmall: 512,
    maxSnowParticles: 15000,
    shadowMapSize: 1024,
    shadowsEnabled: true,
    maxPixelRatio: 1.5,
  },
  high: {
    paintTextureSize: 4096,
    paintTextureSizeSmall: 1024,
    maxSnowParticles: 30000,
    shadowMapSize: 2048,
    shadowsEnabled: true,
    maxPixelRatio: 2,
  },
};

const STORAGE_KEY = 'snow-graffiti.quality';

export function loadQuality(): QualityLevel {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'low' || stored === 'medium' || stored === 'high') return stored;
  return 'medium';
}

export function saveQuality(level: QualityLevel): void {
  localStorage.setItem(STORAGE_KEY, level);
}
